export function ViewWrapper({ children }) {
  return <div className="p-1 h-auto md:p-4">{children}</div>;
}
